import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ListType, NavigationNearestItem } from '@cue/data';

@Pipe({
  name: 'filterStartTargetResourceNearest',
  standalone: true,
})
export class FilterStartTargetResourceNearestPipe implements PipeTransform {
  translocoService = inject(TranslocoService);

  transform(itemList: NavigationNearestItem[], listType: ListType): NavigationNearestItem[] {
    return itemList.filter((item) => {
      switch (listType) {
        case ListType.StartList:
          return item.qrCodes.filter((x) => !x.notNavigationPoint && x.showInStartList).length > 0;
        case ListType.TargetList:
          return item.qrCodes.filter((x) => !x.notNavigationPoint && x.showInTargetList).length > 0;
      }
    });
  }
}
